// @flow

import Formatic from 'formatic';

import formaticPlugin from 'app/common/formaticPlugin';

export default Formatic.createConfig(formaticPlugin);
